import * as React from 'react'
import { SocialSecurityFund, SocialSecuritySubFund } from '../api/client'

interface SocialSecurityFundSelectProps {
  funds: SocialSecurityFund[]
  value: number | null
  onChange: (value: number | null) => void
  placeholder: string
  className?: string
  isDisabled?: boolean
}

export const SocialSecurityFundSelect: React.FC<SocialSecurityFundSelectProps> = ({
  funds,
  value,
  onChange,
  placeholder,
  className,
  isDisabled = false,
}) => {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => {
        const val = e.target.value
        onChange(val ? parseInt(val, 10) : null)
      }}
      disabled={isDisabled}
      className={`flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${className || ''}`}
    >
      <option value="">{placeholder}</option>
      {funds.map((fund) => (
        <option key={fund.id} value={fund.id}>
          {fund.name}{fund.description ? ` - ${fund.description}` : ''}
        </option>
      ))}
    </select>
  )
}

interface SocialSecuritySubFundSelectProps {
  subFunds: SocialSecuritySubFund[]
  value: number | null
  onChange: (value: number | null) => void
  placeholder: string
  className?: string
  isDisabled?: boolean
}

export const SocialSecuritySubFundSelect: React.FC<SocialSecuritySubFundSelectProps> = ({
  subFunds,
  value,
  onChange,
  placeholder,
  className,
  isDisabled = false,
}) => {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => {
        const val = e.target.value
        onChange(val ? parseInt(val, 10) : null)
      }}
      disabled={isDisabled}
      className={`flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${className || ''}`}
    >
      <option value="">{placeholder}</option>
      {subFunds.map((subFund) => (
        <option key={subFund.id} value={subFund.id}>
          {subFund.name}{subFund.description ? ` - ${subFund.description}` : ''}
        </option>
      ))}
    </select>
  )
}
